import React, { Component, useState, useRef, useCallback, useEffect, forwardRef } from 'react'
import { useMount } from 'react-use'
import { useDispatch } from 'react-redux';
import { ZoomInOutlined, DeleteOutlined } from '@ant-design/icons';
import { Spin, Upload, Button, Icon, message } from 'antd'
import cn from 'classnames'
import * as apis from '@/apis'
import styles from './upload.module.scss'
import * as actions from '../../../models/orders/actions'

function UploadFile({ onChange, value = [], disabled, max = 9 }, ref) {
  const [loading, setLoading] = useState(false)
  let a = disabled

  const dispatch = useDispatch();
  const customRequest = useCallback(file => {
    if (loading) return false

    const formData = new FormData()
    formData.append('file', file)
    formData.append('type', 'order-images')
    setLoading(true)

    apis.uploadFile(formData).then(response => {
      const asset = {
        id: Math.random().toString(36).slice(-8),
        name: response.name,
        url: response.url,
        file: response._id,
        type: response.type,
        dimensions: response.dimensions,
        createdAt: new Date()
      }
      const list = [asset, ...value]

      onChange(list)

    }).then(() => {
      message.success('上传成功')
    }).catch(err => {
      message.error(err.message || '图片上传失败')
    }).finally(() => setLoading(false))

    return false
  }, [loading, value])
  const showImageView = useCallback(img => () => {
    let location = `${img.url}?x-oss-process=image/resize,m_fill,h_${img.dimensions.height},w_${img.dimensions.width}/format,webp`
    window.open(location);
    //dispatch(actions.showImageViewDialog({src}));
  });
  const onRemoveHandler = useCallback(id => () => {
    const files = value.filter(item => item.id !== id);
    if (onChange) {
      onChange(files);
    }
  }, [value])

  const uploadButton = (
    <div style={{
      display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: 'pointer',
      width: '78px', height: '78px', border: '1px solid #d9d9d9', borderRadius: '4px'
    }}>
      <Icon type="plus" style={{ fontSize: 36, color: '#D8D8D8' }} />
    </div>
  );

  return (
    <div className={styles.uploadwrap}>
      {
        value.map(item => (
          <div key={item.id} className={styles.item}>
            <img className={styles.img} src={item.url + '?x-oss-process=image/resize,m_fill,h_100,w_100/format,webp'} />
            <div className={styles.overlay}>
              {!disabled && (<span className={styles.delBtn} onClick={onRemoveHandler(item.id)}>
                <DeleteOutlined style={{ color: "#ffffff", fontSize: "20px" }} />
              </span>)
              }

              <span className={styles.delBtn} onClick={showImageView(item)}>
                <ZoomInOutlined style={{ color: "#ffffff", fontSize: "20px" }} />
              </span>
            </div>
          </div>
        ))
      }
      <Upload
        className={cn('avatar-uploader')}
        showUploadList={false}
        beforeUpload={customRequest}
        disabled={disabled}
        accept=".png, .jpg, .jpeg"
      >
        {/* <Button disabled={disabled}>
          <Icon type={loading ? 'loading' : 'plus'} />
          <span>上传</span>
        </Button> */}
        {value.length >= max ? null : uploadButton}
      </Upload>

    </div>
  )
}

export default forwardRef(UploadFile)